<template>
  <O3D>
    <!-- <SwatWalk></SwatWalk> -->
    <Church></Church>
    <!-- <FactoryPlace></FactoryPlace> -->

    <!-- <O3D :py="40" :pz="-100">
      <O3D layout="loklok">
        <WoozyLayer :pz="-5" :py="8"></WoozyLayer>
        <LokLokText></LokLokText>
      </O3D>
    </O3D> -->

    <O3D layout="overall" v-if="ready">
      <O3D :px="0" :pz="80" :py="180">
        <PointLight :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.6"></PointLight>
      </O3D>
      <O3D :px="0" :pz="-80" :py="180">
        <PointLight :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.6"></PointLight>
      </O3D>
      <O3D :px="0" :pz="0" :py="180">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.4"></HemisphereLight>
      </O3D>
      <O3D :px="0" :pz="0" :py="180">
        <AmbinetLight :color="0xffffff" :helper="isDev && isOff" :intensity="0.1"></AmbinetLight>
      </O3D>

      <O3D :pz="-100">

        <O3D :sy="0.25" :sx="0.25" :sz="0.25">
          <CBFloor :floor="0">
            <O3D :px="0" :pz="0" :py="2">
              <GameNPC :char="'ricky'" :dance="'Macarena Dance'"></GameNPC>
            </O3D>
          </CBFloor>
          <CBFloor :floor="1">
            <O3D :px="0" :pz="0" :py="2">
              <GameNPC :char="'suzie'" :dance="'Macarena Dance'"></GameNPC>
            </O3D>
          </CBFloor>
          <CBFloor :floor="2">
            <O3D :px="0" :pz="0" :py="2">
              <GameNPC :char="'david'" :dance="'Macarena Dance'"></GameNPC>
            </O3D>
          </CBFloor>
          <CBFloor :floor="3">
            <O3D :px="0" :pz="0" :py="2">
              <GameNPC :char="'alex'" :dance="'Macarena Dance'"></GameNPC>
            </O3D>
          </CBFloor>
          <CBFloor :floor="4">
            <O3D :px="0" :pz="0" :py="2">
              <GameNPC :char="'janice'" :dance="'Macarena Dance'"></GameNPC>
            </O3D>
          </CBFloor>
        </O3D>


        <!-- <O3D :px="0" :pz="10">
          <GameNPC :char="'suzie'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="10" :pz="5">
          <GameNPC :char="'peter'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="-10" :pz="5">
          <GameNPC :char="'alex'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="20" :pz="0">
          <GameNPC :char="'joe'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="30" :pz="-5">
          <GameNPC :char="'frank'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="-30" :pz="-5">
          <GameNPC :char="'janice'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="-20" :pz="-0">
          <GameNPC :char="'ricky'" :dance="'Macarena Dance'"></GameNPC>
        </O3D> -->


        <!-- <O3D :px="40" :pz="-10">
          <GameNPC :char="'steve'" :dance="'control standing idle'"></GameNPC>
        </O3D>
        <O3D :px="-40" :pz="-10">
          <GameNPC :char="'david'" :dance="'control standing idle'"></GameNPC>
        </O3D> -->

      </O3D>

    </O3D>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { Actions } from '../../GLContent/Game/Actions.js'
import { CharNPC } from '../../GLContent/Game/CharNPC.js'

export default {
  mixins: [O3DG2],
  data () {
    return {
      ready: false,
      layouts: {}
    }
  },
  methods: {
    async setup () {
      let lay = this.layouts
      this.onLoop(() => {
        lay.overall = {
          pz: -50
        }
      })
      this.ready = true
    }
  },
  async mounted () {
    await Promise.all([
      CharNPC.preloadByName({ name: 'suzie' }),
      // CharNPC.preloadByName({ name: 'peter' }),
      CharNPC.preloadByName({ name: 'alex' }),
      // CharNPC.preloadByName({ name: 'steve' }),
      // CharNPC.preloadByName({ name: 'joe' }),
      // CharNPC.preloadByName({ name: 'frank' }),
      CharNPC.preloadByName({ name: 'janice' }),
      CharNPC.preloadByName({ name: 'ricky' }),
      CharNPC.preloadByName({ name: 'david' }),

      Actions.preloadByName({ name: 'Macarena Dance' })
    ])
    this.setup()
  }
}
</script>

<style>

</style>